import React, { useEffect, useState, useRef } from 'react';
import { Canvas, useFrame, extend, useThree } from 'react-three-fiber';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls';
import * as THREE from 'three';

extend({ OrbitControls });

interface CameraControlsProps {
  fov?: number;
  position?: [number, number, number];
  target?: [number, number, number];
  zoomSpeed?: number;
  rotationSpeed?: number;
}

function CameraControls(props: CameraControlsProps): React.ReactElement {
  // Get a reference to the Three.js Camera, and the canvas html element.
  // We need these to setup the OrbitControls class.
  // https://threejs.org/docs/#examples/en/controls/OrbitControls

  const {
    scene,
    camera,
    gl: { domElement },
  } = useThree();

  // Ref to the controls, so that we can update them on every frame using useFrame
  const controls = useRef<any>();

  useEffect(() => {
    // FOV
    if (camera instanceof THREE.PerspectiveCamera) {
      camera.fov = props.fov ?? 40;
      camera.updateProjectionMatrix();
    }
    // Position camera
    const position = props.position ?? [0, 5, 10];
    const target = props.target ?? [scene.position.x, scene.position.y, scene.position.z];
    camera.position.set(position[0], position[1], position[2]);
    camera.lookAt(new THREE.Vector3(target[0], target[1], target[2]));
    if (controls.current) controls.current.target.set(target[0], target[1], target[2]);
  }, []);

  // @ts-ignore
  useFrame((state) => controls.current.update());
  return (
  // @ts-ignore
    <orbitControls
      ref={controls}
      args={[camera, domElement]}
      zoomSpeed={props.zoomSpeed ?? 0.75}
      rotateSpeed={props.rotationSpeed ?? 0.25}
    />
  );
}

export default CameraControls;
